export enum MarketPageType {
  HOME = 'HOME',
  MARKET = 'MARKET',
  SECTOR = 'SECTOR',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}
